document.addEventListener("DOMContentLoaded", () => {
	const nav = document.querySelector('.nav_main');
	const hamburger = document.querySelector('.nav_main-hamburger');

	// ── Hamburger ──────────────────────────────────────
	hamburger.addEventListener('click', () => {
		if (nav.classList.contains('is-open')) {
			const openSubmenus = document.querySelectorAll('.nav_main-item.is-open');
			
			if (openSubmenus.length > 0) {
				// close open submenus first
				openSubmenus.forEach(item => {
					item.classList.remove('is-open');
					item.classList.add('is-closing');
				});
				// then close main menu after short delay
				setTimeout(() => {
					nav.classList.remove('is-open');
					nav.classList.add('is-closing');
				}, 300);
			} else {
				// no open submenus, close immediately
				nav.classList.remove('is-open');
				nav.classList.add('is-closing');
			}
		} else {
			// opening
			nav.classList.add('is-opening');
		}
	});

	nav.addEventListener('transitionend', (e) => {
		if (e.propertyName !== 'grid-template-rows') return;
		if (nav.classList.contains('is-opening')) {
			nav.classList.remove('is-opening');
			nav.classList.add('is-open');
		} else if (nav.classList.contains('is-closing')) {
			nav.classList.remove('is-closing');
		}
	});

	// ── Submenus ───────────────────────────────────────
	document.querySelectorAll('.nav_main-submenu-toggle').forEach(trigger => {
		const parentLi = trigger.closest('li');
		const submenu = trigger.nextElementSibling;

		trigger.addEventListener('click', () => {
			if (parentLi.classList.contains('is-open')) {
				// closing
				parentLi.classList.remove('is-open');
				parentLi.classList.add('is-closing');
			} else {
				// opening
				parentLi.classList.add('is-opening');
			}
		});

		submenu.addEventListener('transitionend', (e) => {
			if (e.propertyName !== 'grid-template-rows') return;
			if (parentLi.classList.contains('is-opening')) {
				parentLi.classList.remove('is-opening');
				parentLi.classList.add('is-open');
			} else if (parentLi.classList.contains('is-closing')) {
				parentLi.classList.remove('is-closing');
			}
		});
	});
});
